import type {
  WalletActionState,
} from '@/components/appDriver/wallet/types'

export function getWalletActionState(balance: number): WalletActionState {
  if (balance < 0) {
    return {
      payableAmount: Math.abs(balance),
      withdrawableAmount: 0,
      canPay: true,
      canWithdraw: false,
      status: 'payable',
    }
  }

  if (balance > 0) {
    return {
      payableAmount: 0,
      withdrawableAmount: balance,
      canPay: false,
      canWithdraw: true,
      status: 'withdrawable',
    }
  }

  return {
    payableAmount: 0,
    withdrawableAmount: 0,
    canPay: false,
    canWithdraw: false,
    status: 'settled',
  }
}

export function formatLakAmount(amount: number, options: { absolute?: boolean, symbol?: string } = {}): string {
  return `${options.symbol ?? '₭'}${formatLakAmountValue(amount, options)}`
}

export function formatLakAmountValue(amount: number, options: { absolute?: boolean } = {}): string {
  const value = options.absolute ? Math.abs(amount) : amount

  return value.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
}

export function maskBankAccountNumber(accountNumber: string): string {
  const digits = accountNumber.replace(/\D/g, '')

  if (digits.length <= 9) {
    return '****'
  }

  return `${digits.slice(0, 4)} **** ****** ${digits.slice(-5)}`
}

export function generateDriverPayDueIdempotencyKey(): string {
  const timestamp = Date.now()
  const randomValue = getRandomIdempotencyValue()

  return `driver-paydue-${timestamp}-${randomValue}`
}

export function generateDriverWithdrawIdempotencyKey(): string {
  const timestamp = Date.now()
  const randomValue = getRandomIdempotencyValue()

  return `driver-withdraw-${timestamp}-${randomValue}`
}

function getRandomIdempotencyValue(): string {
  if (window.crypto?.getRandomValues) {
    const randomValues = new Uint32Array(2)
    window.crypto.getRandomValues(randomValues)

    return Array.from(randomValues)
      .map((value) => value.toString(36))
      .join('')
  }

  return Math.random().toString(36).slice(2, 12)
}
